import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { EntityActions } from 'actions';
import ContentLayout from 'containers/components/layouts/ContentLayout';
import DetailLayout from 'containers/components/layouts/ContentDetailLayout';
import LinkFromWeb3Decorator from 'decorators/LinkFromWeb3Decorator';
import BillboardHeader from './Header';
import BillboardContentNavigator from './ContentNavigator';
import BillboardMenu from './Menu';
import Content from './Content';
import BillboardDetail from './components/Detail';
import { getLiteral } from 'utils/getLiteral';

import './styles.scss';
import { useCallback } from 'react';

const propTypes = {};

const Main = React.memo(() => {
    const dispatch = useDispatch();
    const login = useSelector((state) => state.config.login);
    const isPageForbidden = useCallback(
        (entities) => dispatch(EntityActions.isPageForbidden(entities)),
        [dispatch],
    );

    if (!login) return null;
    if (isPageForbidden(['billboard'])) return null;
    return (
        <ContentLayout header={<BillboardHeader />}>
            <DetailLayout
                header={<BillboardMenu />}
                navigator={<BillboardContentNavigator />}
                navigatorTitle={getLiteral('label_billboard_your_news')}
            >
                <Content />
            </DetailLayout>
            <BillboardDetail />
        </ContentLayout>
    );
});

Main.propTypes = propTypes;

export default LinkFromWeb3Decorator(Main);
